/**
 * @generated SignedSource<<5e7362ef889204d521a73680a5f4ea72>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "orderId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "orderId",
        "variableName": "orderId"
      }
    ],
    "concreteType": "LockerOpeningCode",
    "kind": "LinkedField",
    "name": "GetOrderOpeningCode",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "QRCode",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DepositReadyModalContentGetCodeMutation",
    "selections": (v1/*: any*/),
    "type": "ClientAppMutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DepositReadyModalContentGetCodeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "880b43fa93f2823dfea24cc8a85b3305",
    "id": null,
    "metadata": {},
    "name": "DepositReadyModalContentGetCodeMutation",
    "operationKind": "mutation",
    "text": "mutation DepositReadyModalContentGetCodeMutation(\n  $orderId: Int!\n) {\n  GetOrderOpeningCode(orderId: $orderId) {\n    code\n    QRCode\n  }\n}\n"
  }
};
})();

node.hash = "f8327ce594d1be9faf38ad19745db77b";

module.exports = node;
